import CardList from 'containers/Settings/CardList';
import RelatedSKUsList from 'containers/Settings/List/RelatedSKUs';
import RelatedSKUsEdit from 'containers/Settings/Edit/RelatedSKUs';
import RelatedSKUsCreate from 'containers/Settings/Create/RelatedSKUs';
import LocationsList from 'containers/Settings/List/Locations';
import LocationEdit from 'containers/Settings/Edit/Locations';
import LocationCreate from 'containers/Settings/Create/Locations';
import LocationStockChangesList from 'containers/Settings/List/LocationStockChangesList';

export default {
   CardList,
   RelatedSKUsList,
   RelatedSKUsEdit,
   RelatedSKUsCreate,
   LocationsList,
   LocationEdit,
   LocationCreate,
   LocationStockChangesList
};
